<template>
    <page>
        <module title="成功案例详情">
            <c-form ref="form" unit-width="500">
                <c-form-item label="标题" width="800px">
                    <c-input name="case_title" :disabled="true"></c-input>
                </c-form-item>
                <c-form-item label="封面图" width="800px">
                    <c-file :src="img_url" name="img_url" media type="image" tip="请上传一张封面图片，文件大小建议5M以内"></c-file>
                </c-form-item>
                <c-form-item  label="内容" width="800px">
                    <c-editor name="case_content" :disabled="true"></c-editor>
                </c-form-item>
            </c-form>
        </module>
    </page>
</template>

<script>
var sroutes = {
    path: '/success_case_list',  //列表页在routes中的path
    name: 'm_success_case',  //列表页在routes中的name
    update: 'successCaseUpdate', //列表页定义的返回刷新的方法
    url_detail:'/success_case/detail',  //获取详情的url地址
    url_update:'/success_case/update',  //编辑提交地址
    url_add:'/success_case/add',  //新增地址
};
var name = 'm_success_case';
export default {
    name: name,

    props: {
        id: String
    },

    data() {
        return {
            img_url: ''
        }
    },

    computed: {

    },

    watch: {
        id() {
            this.getDetail();
        },
    },

    mounted() {
        if (this.id) {
            this.getDetail();
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: sroutes.url_detail,
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.img_url = data.img_url;
                    this.$refs.form.set(data);
                }
            });
        }
    }
}
</script>
